(function() {
  const buttonsWrapper = document.querySelector('.product__buttons');
  const customCursor = document.querySelector('.customCursor');
  const body = document.querySelector('body');

  body.onmousemove = function (e) {
    const x = e.clientX - 21;
    const y = e.clientY - 21;

    customCursor.style.left = `${x}px`;
    customCursor.style.top = `${y}px`;

    if (e.clientX - window.innerWidth + 40 >= 0) {
      customCursor.classList.add('customCursor--hidden');
    } else {
      customCursor.classList.remove('customCursor--hidden');
    }
  };

  if (buttonsWrapper) {
    buttonsWrapper.onmouseover = function (e) {
      if (!e.target.matches('.product__buttons--disabled')) {
        customCursor.querySelector('.customCursor__inner').style.width = '40px';
        customCursor.querySelector('.customCursor__inner').style.height = '40px';
        body.classList.add('body--whiteCursor');
      }
    };

    buttonsWrapper.onmouseout = function(e) {
      customCursor.querySelector('.customCursor__inner').style.width = '0px';
      customCursor.querySelector('.customCursor__inner').style.height = '0px';
      body.classList.remove('body--whiteCursor');
    };
  }
})();
